import React, { useState, useContext, useEffect } from "react"
import { useForm } from "react-hook-form";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import axios from "axios";
import { AppContext } from "../contexts"
import { MAX_L_PERSON_NAME, MAX_L_VEHICLE_NO, MIN_L_PERSON_NAME, MIN_L_VEHICLE_NO, REGEX_EMAIL, REGEX_PERSON_NAME } from "@digital/utils";
import { normalizeEmail, normalizeName, normalizeRegNo } from "../utils/normalize";

const EvLeadGenForm = ({ isOpen, toggle, close, lang }) => {
  const state = useContext(AppContext)
  const { insured, vehicle, quotation } = state;
  const [isSubmitting, setIsSubmitting] = useState(false)

  const {
    register,
    handleSubmit,
    errors,
    setValue,
    setError,
    clearError,
    getValues,
  } = useForm({
    defaultValues: {
      registrationNo: vehicle.registrationNo,
      name: insured.name,
      email: insured.email,
    },
  });

  const normalizeContact = (e) => {
    let value = e.target.value
    value = value.replace(/[^0-9]+/g, "")
  }

  const closeBtn = (
    <button className="modal-close" onClick={close}>
      &times;
    </button>
  )

  const onSubmit = async (data) => {
    console.log(errors);

    setIsSubmitting(true);

    let emailData = {};

    emailData = {
      email: data.email,
      vehicleNumber: data.registrationNo,
      name: data.name,
      contactNumber: data.contactNumber,
      type: "EV"
    };

    axios
      .post("/quote/general/customer-service", {
        subject: "ev-quote-customer",
        ...emailData,
      })
      .then(function (response) {
        if (response?.data?.status == "Success") {
          state.setShowResults(true);

          // setTimeout(() => {
          //   close()
          //   state.setShowResults(false);
          //   setIsSubmitting(false);
          // }, 5000)
        }
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  const CorrErrMsg = () => (
    <font color='red'>{lang.simplequote.field_require}</font>
  )

  const Results = () => (
    <div className="mt-3 mb-3 text-left">
      <font color='black'>{lang.errors.msg}</font>
    </div>
  )

  useEffect(() => {
    if (!isOpen) {
      setIsSubmitting(false);
    }
  }, [isOpen]);

  return (
    <div className="overlay" hidden={!isOpen}>
      <Modal isOpen={isOpen} toggle={toggle} className="contact">
        <ModalHeader className="border-0" toggle={toggle} close={closeBtn}>
          {/* {lang.errors.errorOccured}! */}
        </ModalHeader>
        <ModalBody className="pt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-12 mb-3 text-center" style={{ fontSize: "20px" }}>
                  {state.showResults ? lang.errors.successRequest : lang.errors.requestManual}
                </div>

                {state.showResults ?
                  <div className="mt-3 mb-3 text-center">
                    <font color='black'>
                      <p style={{ fontSize: "16px" }}>
                        {lang.errors.msgEv1a} <strong>{lang.errors.msgEv1b}</strong>.{" "}
                        {lang.errors.msgEv2}{" "}
                        {/* <a href={`mailto:${lang.errors.cxEmail}`}><strong>{lang.errors.cxEmail}</strong></a>. */}
                        {lang.errors.msgEv3}
                      </p>
                    </font>
                  </div> :
                  <>
                    <div className="col-md-6 mb-2">
                      <div className="floating">
                        <input
                          className="floating__input"
                          type="text"
                          name="name"
                          placeholder={lang.simplequote.fullname}
                          maxLength={MAX_L_PERSON_NAME}
                          onChange={(e) => normalizeName(e)}
                          ref={register({
                            required: lang?.simplequote?.field_require,
                            minLength: {
                              value: MIN_L_PERSON_NAME,
                              message: lang?.simplequote?.name_short,
                            },
                            pattern: {
                              value: REGEX_PERSON_NAME,
                              message: lang?.simplequote?.invalidFormat,
                            },
                          })}
                        />
                        {/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.fullName} /> */}
                        <label htmlFor="input__username" className="floating__label" data-content={lang.errors.fullName + "*"} />
                      </div>
                      {errors?.name && (
                        <div className="invalid-feedback d-block">
                          {errors?.name?.message}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="floating">
                        <input
                          className="floating__input"
                          type="text"
                          name="email"
                          placeholder="Email"
                          ref={register({
                            required: lang?.simplequote?.field_require,
                            pattern: {
                              value: REGEX_EMAIL,
                              message: lang.simplequote.valid_email,
                            },
                            onChange: (e) => normalizeEmail(e),
                          })}
                        />
                        {/* <label htmlFor="input__username" className="floating__label" data-content={lang.email} /> */}
                        <label
                          htmlFor="input__username"
                          className="floating__label" data-content={lang.simplequote.email + "*"}
                        />
                      </div>
                      {errors?.email && (
                        <div className="invalid-feedback d-block">
                          {errors?.email?.message || errors.email.types?.message}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="floating">
                        <input
                          className="floating__input"
                          type="tel"
                          name="contactNumber"
                          placeholder="Contact Number"
                          maxLength={20}
                          inputmode="numeric"
                          pattern="[0-9]*"
                          onChange={(e) => normalizeContact(e)}
                          ref={register({
                            required: lang?.simplequote?.field_require,
                          })}
                        />
                        <label
                          htmlFor="input__username"
                          className="floating__label" data-content={lang.errors.contactNo}
                        />
                      </div>
                      {errors?.contactNumber && (
                        <div className="invalid-feedback d-block">
                          {errors?.contactNumber?.message}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="floating">
                        <input
                          type="text"
                          name="registrationNo"
                          placeholder="Vehicle Plate Number"
                          className="floating__input"
                          maxLength={MAX_L_VEHICLE_NO}
                          onChange={(e) => normalizeRegNo(e)}
                          ref={register({
                            required: lang?.simplequote?.field_require,
                            minLength: {
                              value: MIN_L_VEHICLE_NO,
                              message: lang?.simplequote?.valid_vehno,
                            },
                          })}
                        />
                        <label
                          htmlFor="input__username"
                          className="floating__label"
                          data-content={lang.simplequote.vehno + "*"}
                        />
                      </div>
                      {errors?.registrationNo && (
                        <div className="invalid-feedback d-block">
                          {errors?.registrationNo?.message}
                        </div>
                      )}
                    </div>
                  </>}

                {state.showResults ? null : (
                  <div className={`col-md-4 offset-md-4`}>
                    <div className="button-box mt-3 mb-3">
                      <button type="submit" className="btn btn-sompo_primary red" disabled={isSubmitting}>{lang.errors.submit}</button>
                    </div>
                  </div>
                )}

              </div>
              {/* {state.showResults ? <Results /> : null} */}
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default EvLeadGenForm